<template>
  <div class="flex justify-start cust-border p2 flex-column" :style="{ '--cust-border-color': 'var(--light-cyan)', '--cust-border-radius': '0px', '--cust-border-width': '2px' }">
    <!-- DESKTOP -->
    <div class="xs-hide sm-hide">
      <div class="col-12 flex justify-start pb2">
        <div v-if="isCaptain" class="cust-border light-cyan-bg h6 flex items-center p1 mr2" :style="{ '--cust-border-color': 'var(--light-cyan)', '--cust-border-radius': '5px' }">
          Capitaine
        </div>
        <div class="cust-border h6 flex items-center p1 mr2" :class="haveSubscription ? 'light-cyan-bg' : 'light-grey-bg'" :style="{ '--cust-border-color': haveSubscription ? 'var(--light-cyan)' : 'var(--light-grey)', '--cust-border-radius': '5px' }">
          {{ haveSubscription ? 'Abonné(e)' : 'Non abonné(e)' }}
        </div>
        <div class="cust-border light-grey-bg h6 flex items-center p1" :style="{ '--cust-border-color': 'var(--light-grey)', '--cust-border-radius': '5px' }">
          {{ isCaptain && !isCaptainPlaying ? 'Non participant' : 'Participant' }}
        </div>
      </div>
      <div class="col-12 flex justify-between">
        <div class="h6">
          {{ gender }} {{ user.firstname }} {{ user.lastname }}
        </div>
      </div>
    </div>

    <!-- MOBILE -->
    <div class="md-hide lg-hide">
      <div class="col-12 flex justify-start pb1 flex-wrap">
        <div v-if="isCaptain" class="cust-border light-cyan-bg h7 flex items-center p1 mr1 mb1" :style="{ '--cust-border-color': 'var(--light-cyan)', '--cust-border-radius': '5px' }">
          Capitaine
        </div>
        <div class="cust-border h7 flex items-center p1 mr1 mb1" :class="haveSubscription ? 'light-cyan-bg' : 'light-grey-bg'" :style="{ '--cust-border-color': haveSubscription ? 'var(--light-cyan)' : 'var(--light-grey)', '--cust-border-radius': '5px' }">
          {{ haveSubscription ? 'Abonné(e)' : 'Non abonné(e)' }}
        </div>
        <div class="cust-border light-grey-bg h7 flex items-center p1 mb1" :style="{ '--cust-border-color': 'var(--light-grey)', '--cust-border-radius': '5px' }">
          {{ isCaptain && !isCaptainPlaying ? 'Non participant' : 'Participant' }}
        </div>
      </div>
      <div class="col-12 flex justify-between">
        <div class="h7">
          {{ gender }} {{ user.firstname }} {{ user.lastname }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
</script>

<script setup>

import { computed } from 'vue';
import { useStore } from '@/store/index';

import { capitalizeFirstLetter } from '@/utils/utils';

const store = useStore();

const isCaptainPlaying = computed(() => store.state.courtSettings.isCaptainPlaying);

const isCaptain = computed(() => !store.state.courtSettings.isInvite);

const haveSubscription = computed(() => store.state.courtSettings.haveSubscription);

const user = computed(() => store.state.user);

const gender = computed(() => capitalizeFirstLetter(user.value.gender));

</script>
